export const attendanceData = 'attendanceData';
export const attendanceDataFiltered = 'attendanceDataFiltered';
export const updateAttendanceCorrectionDataTable = 'updateAttendanceCorrectionDataTable';
export const updateAttendance = 'updateAttendance';
export const setAdminAttendanceRows = "setAdminAttendanceRows";
export const setAdminFilteredAttendance = "setAdminFilteredAttendance";
export const removeAdminAttendanceRow = "removeAdminAttendanceRow";
export const addAdminAttendanceRow = "addAdminAttendanceRow";
export const updateAdminAttendanceRow = "updateAdminAttendanceRow";



